import { apiClient } from '@utils';

export const useSimulatorDeclarationGroups = (batchId: string) => {
  const result = apiClient.customsSimulator.getBatchDeclarationGroups.useQuery(
    ['simulator-declaration-groups', batchId],
    {
      params: { batchId },
    },
    {
      enabled: !!batchId,
      queryKey: ['simulator-declaration-groups', batchId],
    },
  );

  return { ...result, data: result.data?.body?.groupsData || [] };
};
